<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <span>
        <a-icon type="wallet" class="margin-right-small" />
        Account Receivable
      </span>
      <a-button-group
        v-if="getAuth.divisi[0] == 'Keuangan'"
        :size="getScreen ? 'small' : 'default'"
      >
        <a-button @click="handleCreateGeneral" type="primary"
          ><a-icon
            type="plus"
            :class="getScreen ? '' : 'margin-right-small'"
          />{{ getScreen ? "" : "Create Piutang Lain - Lain" }}</a-button
        >
        <a-button @click="handleReload"
          ><a-icon
            type="reload"
            :class="getScreen ? '' : 'margin-right-small'"
          />{{ getScreen ? "" : "Reload" }}</a-button
        >
      </a-button-group>
    </div>
    <div class="wrapper-body">
      <a-card>
        <div style="display: none">
          <a-select
            placeholder="Ex: Need Process ... "
            v-model="tabs.active"
            :disabled="true"
            @change="moreSearch"
            class="width-full"
            initialValue="process"
            allowClear
          >
            <a-select-option value="release">release</a-select-option>
            <a-select-option value="queue">queue</a-select-option>
            <a-select-option value="needprocess">needprocess</a-select-option>
          </a-select>
        </div>
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 21 }">
            <a-input-search v-model="search" placeholder="Quick Search" />
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 3 }">
            <a-button
              :class="getScreen ? 'margin-top' : ''"
              block
              :icon="advancedsearch == 'display:none' ? 'down' : 'up'"
              @click="handleshowMore"
              >{{
                advancedsearch == "display:none" ? "More" : "Less"
              }}</a-button
            >
          </a-col>
        </a-row>
        <a-row :style="advancedsearch" :gutter="16" class="margin-top">
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <div class="m-form-item-wrapper">
              <label>Create Date</label>
              <a-range-picker
                :placeholder="['Start Date', 'End Date']"
                v-model="transactionDt"
                :format="getDefaultDateFormat"
                allowClear
              />
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <div class="m-form-item-wrapper">
              <label>Transaction Type</label>
              <a-select
                placeholder="Ex: All Transaction ... "
                v-model="typetransaction"
                class="width-full"
                initialValue="all"
              >
                <a-select-option value="all">All transaction</a-select-option>
                <a-select-option value="penerimaan kontrak"
                  >Termin Release</a-select-option
                >
                <a-select-option value="piutang lain - lain"
                  >Piutang Lain - lain</a-select-option
                >
              </a-select>
            </div>
          </a-col>
          <!-- <a-col :xs="{ span: 24 }" :lg="{ span: 6 }"> -->
          <!-- <div v-if="tabs.active == 'needprocess'" class="m-form-item-wrapper">
                <label>Revised Status</label>
                <a-select
                  showSearch
                  v-model="revisedStatus"
                  placeholder="Select Status"
                  class="width-full"
                  initialValue="undefined"
                  allowClear
                  :filterOption="filterOption"
                >
                  <a-select-option value="all">All</a-select-option>
                  <a-select-option value="Revised">Revisable</a-select-option>
                  <a-select-option value="Revised Disabled">Can't Revise</a-select-option>
                  <a-select-option value="Revised On Process">Revise On Process</a-select-option>
                </a-select>
              </div> -->
          <!-- </a-col> -->
        </a-row>
      </a-card>
      <div class="bordered">
        <a-tabs
          class="custom-tabs"
          :activeKey="tabs.active"
          @change="handleTab"
        >
          <a-tab-pane v-if="getAuth.divisi[0] == 'Keuangan'" key="needprocess">
            <template slot="tab">
              <span>Need Process</span>&nbsp;
              <a-badge
                class="m-badge m-badge-small"
                :count="needProcess.length"
                :numberStyle="{ backgroundColor: 'red' }"
                v-if="needProcess.length > 0"
              >
              </a-badge>
            </template>
            <a-table
              :rowKey="
                (record, index) => {
                  return index;
                }
              "
              :pagination="pagination"
              size="small"
              bordered
              :scroll="{ x: 1300 }"
              :columns="columns.needProcess"
              :dataSource="needProcess"
              :loading="tabs.loading"
            >
              <template slot="invoice_dt" slot-scope="text, data">
                <span>{{
                  data.invoice_dt
                    ? moment(data.invoice_dt).format(getDefaultDateFormat)
                    : ""
                }}</span>
              </template>
              <template slot="value" slot-scope="text, data">
                <span>{{
                  formatCurrency(data.currency, data.value.replace("e-", ""))
                }}</span>
              </template>
              <template slot="remaining" slot-scope="text, data">
                <span>{{
                  formatCurrency(
                    data.currency,
                    data.remaining ? data.remaining.replace("e-", "") : 0
                  )
                }}</span>
              </template>
              <div slot="aksi" style="align: center" slot-scope="data">
                <a-button-group>
                  <a-button
                    @click="handleManifest(data)"
                    icon="file"
                  ></a-button>
                  <a-button
                    v-if="
                      data.jenis_transaksi.toLowerCase() == 'penerimaan kontrak'
                    "
                    :disabled="data.create_button == 'disabled'"
                    type="primary"
                    @click="handleCreate(data)"
                    >Create Invoice</a-button
                  >

                  <a-button
                    v-if="
                      data.jenis_transaksi.toLowerCase() ==
                      'piutang lain - lain'
                    "
                    type="primary"
                    :id="'cls' + data.id"
                    @click="handleShowValue(data)"
                    ref="saveInputValue"
                    >Installment Payment</a-button
                  >
                </a-button-group>
              </div>
            </a-table>
            <a-modal
              v-model="poupModalEditData"
              :maskClosable="false"
              :closable="false"
              @ok="simpanEditData()"
              ok-text="Save"
              cancel-text="cancel"
              @cancel="cancelEditData()"
              title="Installement Payment"
            >
              <a-spin :spinning="inputEditLoading">
                <a-form-model
                  ref="ruleForm"
                  :model="formModel"
                  :rules="rulesModel"
                >
                  <a-form-model-item
                    :label-col="{ span: 7 }"
                    :wrapper-col="{ span: 17 }"
                  >
                    <span slot="label">No</span>
                    <a-input hidden v-model="formModel.inputEditid"></a-input>
                    <a-input
                      :disabled="true"
                      v-model="formModel.inputEdit_no"
                    ></a-input>
                  </a-form-model-item>
                  <a-form-model-item
                    :label-col="{ span: 7 }"
                    :wrapper-col="{ span: 17 }"
                  >
                    <span slot="label">Description</span>
                    <a-input
                      :disabled="true"
                      v-model="formModel.inputEdit_wk_nm"
                    ></a-input>
                  </a-form-model-item>
                  <a-form-model-item
                    prop="inputEditvalue"
                    has-feedback
                    :label-col="{ span: 7 }"
                    :wrapper-col="{ span: 17 }"
                  >
                    <span slot="label">Value</span>
                    <a-input-number
                      :formatter="
                        (value) =>
                          `${symbolCurrencyES6(
                            formModel.inputEditCUr,
                            0
                          )} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                      "
                      :parser="(value) => value.replace(curReplace, '')"
                      class="m-width-full m-text-align right"
                      v-model="formModel.inputEditvalue"
                      :min="0"
                    />
                  </a-form-model-item>
                </a-form-model>
              </a-spin>
            </a-modal>
          </a-tab-pane>
          <a-tab-pane v-if="getAuth.divisi[0] == 'Keuangan'" key="queue">
            <template slot="tab">
              <span>AR Queue</span>&nbsp;
              <a-badge
                class="m-badge m-badge-small"
                :count="queue.length"
                :numberStyle="{ backgroundColor: 'red' }"
                v-if="queue.length > 0"
              >
              </a-badge>
            </template>
            <a-table
              :rowKey="
                (record, index) => {
                  return index;
                }
              "
              :pagination="pagination"
              size="small"
              bordered
              :scroll="{ x: 1300 }"
              :columns="columns.queue"
              :dataSource="queue"
              :loading="tabs.loading"
            >
              <template slot="invoicedt" slot-scope="text, data">
                <h4 class="margin-remove">{{ data.tlc_create }}</h4>
                <span>{{
                  data.create_dt
                    ? moment(data.create_dt).format(getDefaultDateFormat)
                    : ""
                }}</span>
              </template>
              <template slot="value" slot-scope="text, data">
                <span>{{ formatCurrency(data.currency, data.value) }}</span>
              </template>
              <template slot="status" slot-scope="data">
                <b v-if="data.status=='Not Yet Process'">{{data.status}}</b>
                <a-tag v-else :color="getcolortage(data.status)" class="margin-remove">{{
                  data.status.toUpperCase()
                }}</a-tag>
              </template>
              <template slot="aksi" slot-scope="text, data">
                <a-button-group>
                  <a-tooltip
                    placement="bottomRight"
                    title="View Manifest"
                  >
                    <a-button
                      @click="handleManifest(data)"
                      icon="eye"
                    ></a-button>
                  </a-tooltip>
                  <a-tooltip
                    placement="bottomRight"
                    title="Edit"
                  >
                    <a-button
                      v-if="
                        data.jenis_transaksi.toLowerCase() !==
                        'piutang lain - lain'
                        &&
                        data.status != 'Verified'
                      "
                      @click="handleEditButton(data)"
                      icon="edit"
                      :disabled="data.status=='Verified' || data.status == 'On Process'"
                    ></a-button>
                  </a-tooltip>
                  <a-tooltip
                    placement="bottomRight"
                    title="Process"
                  >
                    <a-button 
                      v-if="data.status != 'Verified'"
                      @click="handleUpload(data)" 
                      :disabled="data.status=='Verified' || data.status == 'On Process'"
                      type="primary"
                      icon="file-done"
                      ></a-button>
                  </a-tooltip>
                  <a-tooltip
                    placement="bottomRight"
                    title="Cancel"
                  >
                    <a-button type="danger" 
                      v-if="data.status != 'Verified'"
                      @click="handleCancelButton(data)"
                      :disabled="data.status == 'On Process'"
                      icon="close"
                    ></a-button>
                  </a-tooltip>
                  <a-tooltip
                    placement="bottomRight"
                    title="Release"
                  >
                    <a-button
                      v-if="data.status == 'Verified'"
                      @click="handleReleaseButton(data)"
                      type="primary"
                      icon="check"
                      :loading="loading.release && data.id==loading.idrelease"
                    >Release</a-button>
                  </a-tooltip>
                </a-button-group>
              </template>
            </a-table>
          </a-tab-pane>
          <a-tab-pane tab="AR Release" key="release">
            <a-table
              :rowKey="
                (record, index) => {
                  return index;
                }
              "
              :pagination="pagination"
              size="small"
              bordered
              :scroll="{ x: 1300 }"
              :columns="columns.release"
              :dataSource="release"
              :loading="tabs.loading"
            >
              <template slot="invoicedt" slot-scope="text, data">
                <h4 class="margin-remove">{{ data.tlc_create }}</h4>
                <span>{{
                  data.create_dt
                    ? moment(data.create_dt).format(getDefaultDateFormat)
                    : ""
                }}</span>
              </template>
              <template slot="value" slot-scope="text, data">
                <span>{{ formatCurrency(data.currency, data.value) }}</span>
              </template>
              <template slot="aksi" slot-scope="text, data">
                <a-button-group>
                  <a-button @click="handleManifest(data)">Manifest</a-button>
                  <a-button
                    @click="handleDocument(data)"
                    icon="eye"
                    type="primary"
                  ></a-button>
                </a-button-group>
              </template>
            </a-table>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>

    <a-modal
      :visible="modalUploadFile"
      @ok="addLampiran"
      width="900px"
      @cancel="cancelLampiran"
      :maskClosable="false"
    >
      <span slot="title">
        <a-icon type="diff" />&nbsp;Process AR
      </span>

      <a-alert
        class="margin-bottom"
        v-if="realAR < 0"
        type="error"
        message="Error"
        description="Real value cannot less than 0"
      ></a-alert>

      <a-spin :spinning="inputEditLoading">
        <a-form :form="formLampiran">
          <div class="container-essential">
            <a-row :gutter="8">
              <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                <a-form-item label="Value AR">
                  <a-input-number
                    v-decorator="[
                      'value_ar',
                      {
                        rules: [{ required: true }],
                        initialValue: formModel.inputEditValue,
                      },
                    ]"
                    :formatter="
                      (value) =>
                        `${initCUr} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    "
                    :parser="(value) => value.replace(curReplace, '')"
                    class="m-width-full m-text-align right"
                    disabled
                  ></a-input-number>
                </a-form-item>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                <a-form-item label="PPN">
                  <a-input-number
                    v-decorator="[
                      'ppn',
                      {
                        rules: [{ required: false }],
                        initialValue: formModel.inputPPN,
                      },
                    ]"
                    :formatter="
                      (value) =>
                        `${initCUr} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    "
                    :parser="(value) => value.replace(curReplace, '')"
                    class="m-width-full m-text-align right"
                    disabled
                  ></a-input-number>
                </a-form-item>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                <a-form-item label="Document Name">
                  <a-input
                    autocomplete="off"
                    v-decorator="['document_name', { rules: [{ required: true }] }]"
                  ></a-input>
                </a-form-item>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                <a-form-item label="Upload Document File">
                  <a-upload
                    :remove="handleRemoveModal"
                    v-decorator="[
                      'upload_document_file',
                      { rules: [{ required: true }] },
                    ]"
                    :showUploadList="true"
                    :fileList="fileListModalLampiran"
                    accept=".jpg, .png, .pdf, .xls, .xlsx"
                    :beforeUpload="beforeUploadModal"
                  >
                    <a-button> <a-icon type="upload" />Select File </a-button>
                  </a-upload>
                </a-form-item>
              </a-col>
            </a-row>
          </div>
        </a-form>
          <a-divider orientation="left">Deduction Detail</a-divider>
        <a-form :form="formDeduction">
          <a-row :gutter="16">
              <a-col :xs="{ span: 24 }" :lg="{ span: 9 }">
                <div class="container-dash">
                  <a-form-item label="Type">
                    <a-select
                      showSearch
                      placeholder="Select Type"
                      v-decorator="[
                        'type_tax',
                        { rules: [{ required: true }], initialValue: deductionDataEdit.type_tax },
                      ]"
                    >
                      <a-select-option
                        v-for="item in type_tax_master"
                        :key="item.key"
                      >{{item.title}}</a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="Description">
                    <a-input
                      :maxLength="255"
                      v-decorator="[
                        'description',
                        { rules: [{ required: true }], initialValue: deductionDataEdit.description },
                      ]"
                    ></a-input>
                  </a-form-item>
                  <a-form-item label="Value tax">
                    <a-input-number
                      v-decorator="[
                        'value_tax',
                        { rules: [{ required: true }], initialValue: deductionDataEdit.value_tax },
                      ]"
                      :formatter="
                        (value) =>
                          `${initCUr} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                      "
                      :parser="(value) => value.replace(curReplace, '')"
                      :min="0"
                      class="m-width-full m-text-align right"
                    ></a-input-number>
                  </a-form-item>
                  <a-form-item label="Upload Tax Document">
                    <a-upload
                      :remove="handleRemoveDtl"
                      v-decorator="[
                        'upload_tax_document',
                        { rules: [{ required: false }], initialValue: deductionDataEdit.upload_tax_document },
                      ]"
                      :showUploadList="true"
                      :fileList="fileListDtlLampiran"
                      accept=".jpg, .png, .pdf, .xls, .xlsx"
                      :beforeUpload="beforeUploadDtl"
                    >
                      <a-button> <a-icon type="upload" />Select File </a-button>
                    </a-upload>
                  </a-form-item>
                  <!-- :loading="newLoading" -->
                  <a-button
                      v-if="deductionDataEdit.length==0"
                      @click="handleAddEditItem"
                      block
                      type="primary"
                      html-type="submit"
                      class="margin-top"
                      ref="addMainBtn2"
                      v-decorator="['addMainBtn']"
                      :loading="loading.addeditdeduction"
                      >Add</a-button
                  >
                  <a-row v-else :gutter="8">
                    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
                      <a-button
                        @click="handleChangeEditItem"
                        block
                        type="primary"
                        html-type="submit"
                        class="margin-top"
                        ref="addMainBtn3"
                        v-decorator="['addMainBtn']"
                        :loading="loading.addeditdeduction"
                        >Save Changes</a-button
                      >
                    </a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                      <a-button
                        @click="handleCancelEditItem"
                        block
                        type="danger"
                        html-type="submit"
                        class="margin-top"
                        ref="addMainBtn4"
                        v-decorator="['addMainBtn']"
                        >Cancel</a-button
                      >
                    </a-col>
                  </a-row>
                </div>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
                <div class="container-headertable">
                    List Details
                 </div>
                <a-config-provider :locale="getLocalConfigProvider()">
                <a-table
                  bordered
                  size="small"
                  id="tbl_dtl"
                  :rowKey="(record, index) => {return index;}"
                  :columns="columns.deduction"
                  :dataSource="deduction_source"
                  :pagination="paginationDeduction"
                  :scroll="{ x: 525}"
                >
                  <template slot="nomor" slot-scope="text, data,index">
                    <div class="m-text-align right">{{index+1}}</div>
                  </template>
                  <template slot="type" slot-scope="data">
                    <div class="m-text-align left">{{ gettitletax(data.type_tax)}}</div>
                    <small><i>{{data.description}}</i></small>
                  </template>
                  <template slot="value" slot-scope="data">
                    <CurrencyJustified
                        :currencyValue="formModel.inputEditCUr"
                        :valueNumber="data.value_tax"
                      />
                  </template>
                  <template slot="action" slot-scope="text,data,index">
                    <div class="m-text-align right">
                    <a-button-group>
                      <a-tooltip class="m-tooltip-inner" placement="bottomRight" title="View File">
                        <a-button
                          v-if="data.upload_tax_document || data.upload_tax_document_name"
                          type="default"
                          @click="viewFiledtl(data)"
                          icon="file"
                          size="small"
                          :disabled="deductionDataisEditing"
                        >
                        </a-button>
                      </a-tooltip>
                      <a-tooltip class="m-tooltip-inner" placement="bottomRight" title="Edit Row">
                        <a-button
                          type="primary"
                          @click="editdtl(data,index)"
                          icon="edit"
                          size="small"
                          :disabled="deductionDataisEditing"
                        >
                        </a-button>
                      </a-tooltip>
                      <a-tooltip class="m-tooltip-inner" placement="bottomRight" title="Delete Row">
                        <a-button
                          type="danger"
                          @click="deletedtl(index)"
                          icon="close"
                          size="small"
                          :disabled="deductionDataisEditing"
                          :loading="loading.deletededuction && loading.deletedeductionKey==data.id_dtl"
                        >
                        </a-button>
                      </a-tooltip>
                  </a-button-group>
                  </div>
                  </template>
                  <template slot="footer">
                    <a-row :gutter="16">
                      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                        <a-statistic
                          title="Total Deduction"
                          :value="formatCurrency(formModel.inputEditCUr, totalDeduction)"
                          class="m-text-align left"
                        />
                      </a-col>
                      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                        <a-statistic
                          title="Real Value AR"
                          :value="formatCurrency(formModel.inputEditCUr, realAR ? realAR : 0)"
                          class="m-text-align left"
                        />
                      </a-col>
                    </a-row>
                  </template>
                </a-table>
                </a-config-provider>
              </a-col>
            </a-row>
        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button
              @click="handleAddEditDtl"
              type="primary"
              html-type="submit"
              class="margin-top"
              :disabled="inputEditLoading"
              >Save</a-button
            >
      </template>
    </a-modal>

    <a-modal
      :visible="modalARGeneral"
      @ok="addARGeneral"
      width="500px"
      @cancel="cancelARGeneral"
      ok-text="Submit"
      cancel-text="Cancel"
      :maskClosable="false"
      :confirmLoading="loading.submitARGeneral"
    >
      <span slot="title">
        <a-icon type="diff" />&nbsp;Upload Attachment
      </span>

      <a-form :form="formARGeneral">
        <a-form-item label="Id" hidden>
            <a-input
              autocomplete="off"

              v-decorator="['id', { rules: [{ required: false }] }]"
            ></a-input>
          </a-form-item>
          <a-form-item label="jenis_transaksi" hidden>
            <a-input
              autocomplete="off"
              v-decorator="['jenis_transaksi', { rules: [{ required: false }] }]"
            ></a-input>
          </a-form-item>
        <a-form-item label="Document Name">
          <a-input
            autocomplete="off"
            v-decorator="['document_name', { rules: [{ required: true }] }]"
          ></a-input>
        </a-form-item>
        <a-form-item label="Upload Document File">
          <a-upload
            :remove="handleRemoveModalARGeneral"
            v-decorator="[
              'upload_document_file',
              { rules: [{ required: true }] },
            ]"
            :showUploadList="true"
            :fileList="fileListModalARGeneral"
            accept=".jpg, .png, .pdf, .xls, .xlsx"
            :beforeUpload="beforeUploadModalARGeneral"
          >
            <a-button> <a-icon type="upload" />Select File </a-button>
          </a-upload>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "account-receiveable-index",
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === null) {
        callback(new Error("Please input value"));
      } else if (value <= 0) {
        callback(new Error("value must be greater than 0"));
      } else if (value > parseFloat(this.formModel.inputmax)) {
        callback(
          new Error(
            "Max value is " +
              this.formatCurrency(
                this.formModel.inputcurr,
                parseFloat(this.formModel.inputmax)
              )
          )
        );
      } else {
        this.$refs.ruleForm.validateField("inputEditvalue");
        callback();
      }
    };
    let type_tax_master = [
      { key: 'fee_lain_lain', title: 'Fee Lain-lain' },
      { key: 'commision', title: 'Komisi' },
      { key: 'pph_22_15',title:'PPh 22-15 %'},
      { key: 'pph_23', title: 'PPh 23' },
      { key: 'pph_21', title: 'PPh 21' },
      { key: 'pph_pasal4', title: 'PPh Pasal 4 ayat 2' },
      { key: 'pph_2529', title: 'PPh 25/29 Badan' },
      // { key: 'ppn', title: 'PPN' },
      // {key:'ppn_dipungut',title:'PPN Dipungut'},
      // {key:'ppn_memungut',title:'PPN Memungut'},
      // {key:'ppn_migas',title:'PPN MIGAS'},
      // {key:'ppn_sktd',title:'PPN SKTD'},
      ];
    return {
      type_tax_master,
      tabs: {
        active: "needprocess",
        loading: false,
      },
      release: [],
      needProcess: [],
      queue: [],
      release_origin: [],
      needProcess_origin: [],
      queue_origin: [],
      search: undefined,
      typetransaction: "all",
      transactionDt: [],
      advancedsearch: "display:none",
      buktiTransfer: [],
      modalUploadFile: false,
      poupModalEditData: false,
      formModel: {
        inputEditid: "",
        inputEdit_no: "",
        inputEdit_wk_nm: "",
        inputEditvalue: "",
        inputPPN: 0,
        inputEditCUr: "IDR",
        inputEditjns: "",
        inputmax: 0,
        inputcurr: "",
        inputTypePPN: ""
      },
      rulesModel: {
        inputEditvalue: [
          { required: true, validator: validatePass, trigger: "blur" },
        ],
      },
      inputEditLoading: false,

      fileListModalLampiran: [],
      fileListDtlLampiran:[],
      pagination: {
        onChange: (page) => {
          this.pagination.page = page;
        },
        page: 1,
        pageSize: 10,
        size: "small",
      },
      tempCalc: {
        fee_lain: 0,
        pph22_15: 0,
        pph23: 0,
        komisi:0
      },
      deduction_source: [],
      paginationDeduction: {
        onChange: (page) => {
          this.pagination.page = page;
        },
        page: 1,
        pageSize: 10,
        size: "small",
      },
      deductionDataEdit: [],
      loading: {
        release: false,
        idrelease: "",
        submitARGeneral:false,
        addeditdeduction: false,
        deletededuction: false,
        deletedeductionKey: ""
      },
      modalARGeneral: false,
      fileListModalARGeneral: [],
    };
  },
  mounted() {
    if (this.getAuth.divisi[0] == "Akuntansi" || this.getAuth.divisi[0] == "Financial Control") {
      this.tabs.active = "release";
    }
    Event.$on("handleCancel", this.cancelAR);
  },
  beforeDestroy() {
    Event.$off("handleCancel", this.cancelAR);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
      const columns = {
        release: [
          {
            title: "#",
            key: "nomor",
            dataIndex: "nomor",
            width: 40,
            align: "center",
          },
          {
            title: "No",
            key: "no",
            dataIndex: "no_transaksi",
            width: 230,
          },
          {
            title: "Description",
            key: "work_nm",
            dataIndex: "work_nm",
            width: 250,
          },
          {
            title: "Project Name - Code",
            key: "project_nm_code",
            width: 200,
            dataIndex: "project_nm_code",
          },
          {
            title: "Create By",
            key: "create_by",
            scopedSlots: { customRender: "invoicedt" },
            width: 150,
          },
          {
            title: "Jenis_transaction",
            key: "jenis_transaksi",
            width: 150,
            dataIndex: "jenis_transaksi_remark",
          },
          {
            title: "AR Number",
            key: "ar_no",
            width: 150,
            dataIndex: "ar_no",
          },
          {
            title: "No Invoice",
            key: "invoice_no",
            width: 150,
            dataIndex: "invoice_no",
          },
          {
            title: "Value",
            key: "value",
            scopedSlots: { customRender: "value" },
            width: 150,
            align: "right",
          },
          {
            title: "No BKM",
            key: "no_bkm",
            dataIndex: "no_bkm",
            width: 150,
          },
          {
            title: "Action",
            key: "action",
            width: 160,
            scopedSlots: { customRender: "aksi" },
            fixed: this.getScreen ? false : "right",
            align: "right",
          },
        ],
        queue: [
          {
            title: "#",
            key: "nomor",
            dataIndex: "nomor",
            width: 40,
            align: "center",
          },
          {
            title: "No",
            key: "no",
            dataIndex: "no_transaksi",
            width: 230,
          },
          {
            title: "Description",
            key: "work_nm",
            dataIndex: "work_nm",
            width: 250,
          },
          {
            title: "Project Name - Code",
            key: "project_nm_code",
            width: 200,
            dataIndex: "project_nm_code",
          },
          {
            title: "Create By",
            key: "create_by",
            scopedSlots: { customRender: "invoicedt" },
            width: 100,
          },
          {
            title: "Transaction Type",
            key: "jenis_transaksi",
            width: 150,
            dataIndex: "jenis_transaksi_remark",
          },
          {
            title: "AR Number",
            key: "ar_no",
            width: 200,
            dataIndex: "ar_no",
          },
          {
            title: "Invoice no",
            key: "invoice_no",
            width: 150,
            dataIndex: "invoice_no",
          },
          {
            title: "Value",
            key: "value",
            scopedSlots: { customRender: "value" },
            width: 150,
            align: "right",
          },
          {
            title: "Status",
            key: "status",
            scopedSlots: { customRender: "status" },
            width: 120,
            fixed: this.getScreen ? false : "right",
            align: "center",
          },
          {
            title: "Action",
            key: "action",
            width: 150,
            scopedSlots: { customRender: "aksi" },
            fixed: this.getScreen ? false : "right",
            align: "right",
          },
        ],
        needProcess: [
          {
            title: "#",
            key: "nomor",
            dataIndex: "nomor",
            width: 40,
            align: "center",
          },
          {
            title: "No",
            key: "no",
            dataIndex: "no_transaction",
            width: 200,
          },
          {
            title: "Description",
            key: "workname",
            dataIndex: "work_nm",
            width: 200,
          },
          {
            title: "Project Name - Code",
            key: "project_nm_code",
            dataIndex: "project_nm_code",
            width: 250,
          },
          {
            title: "Create Date",
            key: "invoice_dt",
            scopedSlots: { customRender: "invoice_dt" },
            align: "center",
          },
          {
            title: "Transaction Type",
            key: "jns_trans",
            dataIndex: "jenis_transaksi_remark",
          },
          {
            title: "Value",
            key: "value",
            scopedSlots: { customRender: "value" },
            align: "right",
          },
          {
            title: "Remaining",
            key: "remaining",
            scopedSlots: { customRender: "remaining" },
            align: "right",
          },
          {
            title: "Action",
            key: "action",
            scopedSlots: { customRender: "aksi" },
            fixed: this.getScreen ? false : "right",
            align: "right",
          },
        ],
        deduction: [
          {
            title: "#",
            key: "nomor",
            scopedSlots: { customRender: "nomor" },
            width:"50px",
          },
          {
            title: "Type | Description",
            key: "type",
            scopedSlots: { customRender: "type" },
            width:"240px",
          },
          {
            title: "Value",
            key: "value",
            scopedSlots: { customRender: "value" },
            width:"150px",
          },
          {
            title: "Action",
            key: "action",
            align: "center",
            scopedSlots: { customRender: "action" },
            fixed:"right",
            width:"85px",
          },
        ],
      };
      return columns;
    },
    moreSearch: function () {
      let tempData = [];
      if (this.tabs.active == "release") {
        tempData = this.release_origin;
      } else if (this.tabs.active == "queue") {
        tempData = this.queue_origin;
      } else {
        tempData = this.needProcess_origin;
      }

      if (tempData.length > 0) {
        if (this.search) {
          tempData = tempData.filter(
            (obj) =>
              obj.searchQ &&
              obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
          );
          this.intoList(this.tabs.active, tempData);
        }

        if (this.typetransaction && this.typetransaction !== "all") {
          tempData = tempData.filter(
            (obj) =>
              obj.jenis_transaksi &&
              obj.jenis_transaksi.toLowerCase() ==
                this.typetransaction.toLowerCase()
          );
        }

        if (this.transactionDt && this.transactionDt.length > 0) {
          let startDt = moment(this.transactionDt[0]).format("YYYY-MM-DD");
          let endDt = moment(this.transactionDt[1]).format("YYYY-MM-DD");
          if (this.tabs.active == "needprocess") {
            tempData = tempData.filter(
              (obj) =>
                obj.invoice_dt &&
                moment(obj.invoice_dt).format("YYYY-MM-DD") >= startDt &&
                moment(obj.invoice_dt).format("YYYY-MM-DD") <= endDt
            );
          } else {
            tempData = tempData.filter(
              (obj) =>
                obj.create_dt &&
                moment(obj.create_dt).format("YYYY-MM-DD") >= startDt &&
                moment(obj.create_dt).format("YYYY-MM-DD") <= endDt
            );
          }
        }
      }

      this.intoList(this.tabs.active, tempData);
      if (
        !this.tabs.active &&
        !this.search &&
        !this.transactionDt &&
        !this.typetransaction
      ) {
        this.intoList(this.tabs.active, tempData);
      }
      return true;
    },
    initCUr() {
      return this.symbolCurrencyES6(this.formModel.inputEditCUr, 0);
    },
    curReplace() {
      return eval(
        "/\\" +
          this.symbolCurrencyES6(this.formModel.inputEditCUr, 1) +
          "\\s?|(,*)/g"
      );
    },
    realAR() {
      return (
        parseFloat(this.formModel.inputEditValue) - (this.formModel.inputTypePPN=='ppn_memungut' ? 0 : parseFloat(this.formModel.inputPPN)) - this.totalDeduction
      );
    },
    pageType(){
      if (this.getAuth.divisi[0] == "Akuntansi") {
        this.tabs.active = "release";
      }
      return this.tabs.active
    },
    totalDeduction(){
      let res = 0;
      if(this.deduction_source.length>0)
        this.deduction_source.forEach((element) => {
          res += Number(element.value_tax)
        });
      return res;
    },
    deductionDataisEditing(){
      return !_.isEmpty(this.deductionDataEdit);
    },
  },
  created() {
    this.handleReload();
  },
  beforeCreate() {
    this.formLampiran = this.$form.createForm(this);
    this.formDeduction = this.$form.createForm(this);
    this.formARGeneral = this.$form.createForm(this);
  },
  methods: {
    moment,
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    resetSearch() {
      this.search = undefined;
      this.transactionDt = undefined;
      this.typetransaction = "all";
    },
    intoList(type, value) {
      _.forEach(value, (data, index) => {
        value[index].nomor = index + 1;
      });
      if (type == "release") {
        this.release = value;
      } else if (type == "queue") {
        this.queue = value;
      } else {
        this.needProcess = value;
      }
    },
    handleReload() {
      this.tabs.loading = true;
      let urlfetch = "getAccountReceive";
      this.$store
        .dispatch(urlfetch, {
          tab: null,
          jenis: null,
          tlc: this.getAuth.username,
        })
        .then(
          (res) => {
            this.release = res.data.release;
            _.forEach(this.release, (data, index) => {
              this.release[index].searchQ =
                this.release[index].invoice_no +
                this.release[index].ar_no +
                this.release[index].no_transaksi +
                this.formatCurrency(
                  this.release[index].currency,
                  this.release[index].value
                ) +
                this.release[index].tlc_create +
                this.release[index].work_nm +
                this.release[index].project_nm_code +
                this.release[index].no_bkm +
                this.release[index].jenis_transaksi +
                moment(this.release[index].create_dt).format(
                  this.getDefaultDateFormat
                );
              this.release[index].nomor = index + 1;
            });

            this.needProcess = res.data.need_process;
            _.forEach(this.needProcess, (data, index) => {
              this.needProcess[index].searchQ =
                this.needProcess[index].no_transaction +
                this.needProcess[index].work_nm +
                moment(this.needProcess[index].invoice_dt).format(
                  this.getDefaultDateFormat
                ) +
                this.formatCurrency(
                  this.needProcess[index].currency,
                  this.needProcess[index].value
                ) +
                this.needProcess[index].project_nm_code +
                this.needProcess[index].jenis_transaksi;
              this.needProcess[index].nomor = index + 1;
            });

            this.queue = res.data.queue;
            _.forEach(this.queue, (data, index) => {
              this.queue[index].searchQ =
                this.queue[index].invoice_no +
                this.queue[index].no_transaksi +
                this.formatCurrency(
                  this.queue[index].currency,
                  this.queue[index].value
                ) +
                this.queue[index].tlc_create +
                this.queue[index].work_nm +
                this.queue[index].ar_no +
                this.queue[index].project_nm_code +
                this.queue[index].tlc_create +
                moment(this.queue[index].create_dt).format(
                  this.getDefaultDateFormat
                ) +
                this.queue[index].jenis_transaksi;
              this.queue[index].nomor = index + 1;
            });

            this.release_origin = this.release;
            this.needProcess_origin = this.needProcess;
            this.queue_origin = this.queue;

            this.tabs.loading = false;
          },
          (error) => {
            this.release = [];
            this.needProcess = [];
            this.queue = [];

            this.release_origin = [];
            this.needProcess_origin = [];
            this.queue_origin = [];

            let responses = Object.assign({}, error);
            this.displayMessageValue("error-other", responses);
            this.tabs.loading = false;
          }
        );
      this.resetSearch();
    },
    handleTab(val) {
      this.tabs.active = val;
      this.resetSearch();
    },
    handleCreate(item) {
      this.$router.push({
        name: "createNgeneral-account-receive",
        params: { id: item.id },
      });
    },
    handleCancelButton(item) {
      this.confirmMessageValue("confirm-cancel", item, null);
    },
    cancelAR(item) {
      this.tabs.loading = true;
      this.$store
        .dispatch("releaseAR", {
          auth: this.getAuth,
          id: item.id,
          jenis_transaksi:
            item.jenis_transaksi == "Penerimaan Kontrak"
              ? "Penerimaan_Kontrak"
              : "Piutang_lain_lain",
        })
        .then((response) => {
          this.tabs.loading = false;
          this.formModel.inputEditid = "";
          this.formModel.inputEditjns = "";
          this.displayMessageValue("success-other", response.message);
          this.handleReload();
        })
        .catch((error) => {
          this.tabs.loading = false;
          let responses = Object.assign({}, error);
          if (responses.response.data) {
            this.displayMessageValue(
              "error-other",
              responses.response.data.message
            );
          } else {
            this.displayMessageValue("error-other", responses.response);
          }
        });
    },
    handleManifest(item) {
      if (
        this.tabs.active == "needprocess" &&
        item.jenis_transaksi == "Penerimaan Kontrak"
      ) {
        this.$router.push({
          name: "manifestSalesContractKeu",
          params: {
            p_auth: { username: item.user_pembuat },
            tlc_pembuat: item.user_pembuat,
            id: item.id,
          },
        });
      } else {
        this.$router.push({
          name:
            this.getAuth.divisi == "Keuangan"
              ? "account-receive-manifest"
              : "account-receivable-manifest",
          params: {
            id: item.id,
            tab: this.tabs.active,
            jns:
              item.jenis_transaksi == "Penerimaan Kontrak"
                ? "Penerimaan_Kontrak"
                : "Piutang_lain_lain",
          },
        });
      }
    },
    handleUpload(item) {
      if (item.jenis_transaksi == "Piutang lain - lain") {
        this.modalARGeneral = true;
        this.$nextTick(function () {
          this.formARGeneral.setFieldsValue({
            id: item.id,
            jenis_transaksi: item.jenis_transaksi,
          });
        });
      } else {
        //if (item.status == 'Revised') {
          this.asyncAxiosGet(
            "account_receivable/proses",
            this.getAuth,
            {
              id: item.id,
            }
          ).then((response) => {
            this.deduction_source = response.dtl;
            this.modalUploadFile = true;
            this.formModel = {
              ...this.formModel,
              inputEditid: item.id,
              inputEditjns: item.jenis_transaksi,
              inputEditCUr: item.currency,
              inputEditValue: item.value,
              inputPPN: response.ppn,
              inputTypePPN: response.type_ppn
            };

            let file = null;
            if (response.upload_document_file != null) {
              let typefile = this.fileTypeFromUrl(response.upload_document_name);
              file = this.dataURLtoFile(typefile + response.upload_document_file, response.upload_document_name);
              file.uid = 'vc-upload-1-1';
              file.status = 'done';
              file.exist = true;
              file.url = this.$serviceUrl + response.upload_document_path;
              this.fileListModalLampiran = [];
              this.fileListModalLampiran.push(file);
            }
            this.$nextTick(function () {
                this.formLampiran.setFieldsValue({
                  document_name: response.document_name,
                  upload_document_file: file
                });
              });
          }).catch((err) => {
            console.log(err);
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
          });
        // } else {
        //   this.modalUploadFile = true;
        //   this.formModel = {
        //     ...this.formModel,
        //     inputEditid: item.id,
        //     inputEditjns: item.jenis_transaksi,
        //     inputEditCUr: item.currency,
        //     inputEditValue: item.value,
        //   };
        // }
      }
    },
    handleDocument(item) {
      window.open(this.$serviceUrl + item.file_path, "_blank");
    },
    handleClose() {
      this.modalUploadFile = false;
    },
    handleshowMore() {
      if (this.advancedsearch == "display:none") {
        this.advancedsearch = "display:block";
      } else {
        this.advancedsearch = "display:none";
      }
    },

    handleRevisiAndClose(item) {
      const that = this;
      let title = "";
      let messageSukses = "";
      title = "Are you sure to revise this data";
      messageSukses = "Successfully revise data";

      this.$confirm({
        title: title,
        content: "Batal / OK?",
        onOk() {
          let promise = new Promise((resolve, reject) => {
            let data = {
              tlc: that.getAuth.username,
              aksi: item.button_aksi,
              id: item.id,
              jenis_transaksi: item.jenis_transaksi,
            };

            axios({
              method: "post",
              url: that.$serviceUrl + "account_pay/aksi_account_pay",
              data: data,
              auth: {
                username: that.getAuth.username,
                password: that.getAuth.password,
              },
              headers: {
                "Content-Type": "application/json",
                "X-API-KEY": that.getAuth.apikey,
              },
            })
              .then(({ data }) => {
                resolve(data);
              })
              .catch((err) => {
                reject(err);
              });
          }).catch(() => console.log("Oops errors!"));
          promise
            .then(() => {
              that.displayMessageValue("success-other", messageSukses);
              that.handleReload();
            })
            .then((err) => {
              if (err) {
                let responses = Object.assign({}, err.response.data);
                that.displayMessageValue("error-other", responses.message);
              }
            });
          return promise;
        },
        onCancel() {},
      });
    },
    handleShowValue(val) {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields();
      }
      console.log("handleShowValue", val)
      this.formModel.inputEditvalue = val.remaining ? val.remaining : 0;
      this.formModel.inputEditCUr = val.currency;
      this.formModel.inputEdit_no = val.no_transaction;
      this.formModel.inputEdit_wk_nm = val.work_nm;
      this.formModel.inputEditid = val.id;
      this.formModel.inputmax = val.remaining ? parseFloat(val.remaining) : 0;
      this.formModel.inputcurr = val.currency;
      this.poupModalEditData = true;
    },
    simpanEditData() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        this.inputEditLoading = true;

        let post = new FormData();
        post.append("tlc", this.getAuth.username);
        post.append("id", this.formModel.inputEditid);
        post.append("value", this.formModel.inputEditvalue);

        if (parseFloat(this.formModel.inputEditvalue) <= 0) {
          this.displayMessageValue(
            "error-other",
            "Value must be greater than 0"
          );
          this.inputEditLoading = false;
          return;
        }

        axios({
          method: "post",
          url: this.$serviceUrl + "account_receivable/ar_general_input_value",
          processData: false,
          data: post,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.inputEditLoading = false;
            this.poupModalEditData = false;
            this.displayMessage("success-edit");
            this.handleReload();
          })
          .catch((error) => {
            this.inputEditLoading = false;
            let responses = Object.assign({}, error);
            if (responses.response.data) {
              this.displayMessageValue(
                "error-other",
                responses.response.data.message
              );
            } else {
              this.displayMessageValue("error-other", responses.response);
            }
          });
      });
    },
    cancelEditData() {
      this.poupModalEditData = false;
    },
    handleCreateGeneral() {
      this.$router.push({
        name: "creategeneral-account-receive",
        params: {},
      });
    },
    handleEditButton(data) {
      this.$router.push({
        name: "editNgeneral-account-receive",
        params: { id: data.id },
      });
    },
    addLampiran(e) {
      e.stopPropagation();
      this.visibleLampiran = !this.visibleLampiran;
    },
    cancelLampiran() {
      this.tempCalc = {
        fee_lain: 0,
        pph22_15: 0,
        pph23: 0,
        komisi: 0,
      };
      this.fileListModalLampiran = [];
      this.deduction_source = [];
      this.formLampiran.resetFields();
      this.modalUploadFile = false;
    },
    handleRemoveModal(file) {
      const index = this.fileListModalLampiran.indexOf(file);
      const newFileList = this.fileListModalLampiran.slice();
      newFileList.splice(index, 1);
      this.fileListModalLampiran = newFileList;
    },
    handleRemoveDtl(file){
      const index = this.fileListDtlLampiran.indexOf(file);
      const newFileList = this.fileListDtlLampiran.slice();
      newFileList.splice(index, 1);
      this.fileListDtlLampiran = newFileList;
    },
    handleRemoveModalARGeneral() {
      this.fileListModalARGeneral = [];
    },
    beforeUploadModal(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 10) {
        this.displayMessage("large-file-10mb");
      } else {
        this.fileListModalLampiran = [];
        this.fileListModalLampiran.push(file);
      }
      return false;
    },
    beforeUploadDtl(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 10) {
        this.displayMessage("large-file-10mb");
      } else {
        this.fileListDtlLampiran = [];
        this.fileListDtlLampiran.push(file);
      }
      return false;
    },
    beforeUploadModalARGeneral(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 10) {
        this.displayMessage("large-file-10mb");
      } else {
        this.fileListModalARGeneral = [];
        this.fileListModalARGeneral.push(file);
      }
      return false;
    },
    handleAddEditDtl() { 
      this.formLampiran.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        if (this.fileListModalLampiran.length == 0) {
          this.displayMessage("form-warning");
          return;
        }

        if (this.deduction_source.length == 0) {
          this.displayMessageValue("error-other", "List Details Can't be empty!");
          return;
        }

        if(this.realAR<0){
          this.displayMessageValue("error-other", "Real Value AR Can't be minus!");
          return;
        }

        let formData = new FormData();
        formData.append("tlc", this.getAuth.username);
        formData.append("id", this.formModel.inputEditid);
        formData.append("jenis_transaksi", this.formModel.inputEditjns);
        formData.append("document_name", values.document_name);
        formData.append("upload_document_file", this.fileListModalLampiran[0]);

        this.deduction_source.forEach((element,index) => {
          if(element.id_dtl)
            formData.append(`id_dtl[${index}]`, element.id_dtl);
          formData.append(`type_tax[${index}]`, element.type_tax ? element.type_tax : "");
          formData.append(`description[${index}]`, element.description ? element.description : "");
          formData.append(`value_tax[${index}]`, element.value_tax ? element.value_tax : "");
          if(element.upload_tax_document && element.upload_tax_document.file)
          formData.append(`upload_tax_document[${index}]`, element.upload_tax_document.file);
        });

        formData.append("total_pajak", this.totalDeduction);

        this.inputEditLoading = true;
        axios({
          method: "post",
          url: this.$serviceUrl + "account_receivable/proses",
          processData: false,
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.inputEditLoading = false;

            this.formModel.inputEditid = "";
            this.formModel.inputEditjns = "";
            this.formLampiran.resetFields();

            this.displayMessage("success-upload");
            this.modalUploadFile = !this.modalUploadFile;
            this.tempCalc = {
              fee_lain: 0,
              pph22_15: 0,
              pph23: 0,
              komisi: 0,
            };
            this.fileListModalLampiran = [];
            this.deduction_source = [];
            this.handleReload();
          })
          .catch((error) => {
            this.inputEditLoading = false;

            let responses = Object.assign({}, error);
            if (responses.response.data) {
              this.displayMessageValue(
                "error-other",
                responses.response.data.message
              );
            } else {
              this.displayMessageValue("error-other", responses.response);
            }
          });
      });
    },
    handleAddEditItem(){
      this.formDeduction.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let exist = _.filter(this.deduction_source,(item)=> item.type_tax==values.type_tax 
          && item.description.toLowerCase()==values.description.toLowerCase());
        if(exist.length>0){
          this.displayMessageValue("error-other", "Data with type and description entry is exist!");
          return;
        }

        let formData = new FormData();

        let isvalid = true
        this.formLampiran.validateFields((err, values) => {
          if(values.document_name){
            formData.append("document_name", values.document_name);
            if(this.fileListModalLampiran && this.fileListModalLampiran[0]){
              formData.append("upload_document_file", this.fileListModalLampiran[0]);
            }else{
              this.displayMessageValue("error-other", "Upload Document File must be entried cause the document name has been entried!");
              isvalid = false
            }
          }
        })
        if(!isvalid){
          return;
        }

        
        formData.append("tlc", this.getAuth.username);
        formData.append("id", this.formModel.inputEditid);
        formData.append("jenis_transaksi", this.formModel.inputEditjns);

        formData.append(`type_tax`, values.type_tax);
        formData.append(`description`, values.description);
        formData.append(`value_tax`, values.value_tax);
        if(values.upload_tax_document && values.upload_tax_document.file)
          formData.append(`upload_tax_document`, values.upload_tax_document.file);

        this.loading.addeditdeduction = true;
        axios({
          method: "post",
          url: this.$serviceUrl + "account_receivable/deduction",
          processData: false,
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            // this.deduction_source.push(values);
            this.deduction_source = response.data.dtl;
            this.formDeduction.resetFields();
            this.formLampiran.resetFields();
            this.fileListDtlLampiran = [];
            
            let file = null;
            if (response.data.upload_document_file != null) {
              let typefile = this.fileTypeFromUrl(response.data.upload_document_name);
              file = this.dataURLtoFile(typefile + response.data.upload_document_file, response.data.upload_document_name);
              file.uid = 'vc-upload-1-1';
              file.status = 'done';
              file.exist = true;
              file.url = this.$serviceUrl + response.data.upload_document_path;
              this.fileListModalLampiran = [];
              this.fileListModalLampiran.push(file);
            }
            this.$nextTick(function () {
              this.formLampiran.setFieldsValue({
                document_name: response.data.document_name,
                upload_document_file: file
              });
            });

            this.loading.addeditdeduction = false;
          })
          .catch((error) => {
            this.loading.addeditdeduction = false;

            let responses = Object.assign({}, error);
            if (responses.response.data) {
              this.displayMessageValue(
                "error-other",
                responses.response.data.message
              );
            } else {
              this.displayMessageValue("error-other", responses.response);
            }
          });
      });
    },
    gettitletax(val){
      let res = _.filter(this.type_tax_master,(el)=>el.key==val);
      return res[0].title;
    },
    viewFiledtl(val){
      let typefile = this.fileTypeFromUrlBasic(val.upload_tax_document.file.name);
      let blob = new Blob([val.upload_tax_document.file], { type: typefile, }),
      url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
    },
    editdtl(val, index) {
      if (val.upload_tax_document_path) {
        this.asyncAxiosGet("main/base_64", this.getAuth, {
          path: val.upload_tax_document_path,
        })
        .then((response) => {
          let typefile = this.fileTypeFromUrl(val.upload_tax_document_name);
          let file = this.dataURLtoFile(
            typefile + response.file_document_tax,
            val.upload_tax_document_name
          );
          file.uid = "vc-upload-1-1";
          file.status = "done";
          file.url = this.$serviceUrl + val.upload_tax_document_path;

          this.deductionDataEdit = val;
          this.deductionDataEdit['index'] = index;
          this.upload_tax_document = [];
          this.upload_tax_document.push(file);
          this.fileListDtlLampiran.push(file);
          this.$nextTick(function () {
              this.formDeduction.setFieldsValue({
                upload_tax_document: file,
              });
            });

          let file2 = null;
          if (response.data.upload_document_file != null) {
            let typefile = this.fileTypeFromUrl(response.data.upload_document_name);
            file2 = this.dataURLtoFile(typefile + response.data.upload_document_file, response.data.upload_document_name);
            file2.uid = 'vc-upload-1-1';
            file2.status = 'done';
            file2.exist = true;
            file2.url = this.$serviceUrl + response.data.upload_document_path;
            this.fileListModalLampiran = [];
            this.fileListModalLampiran.push(file);
          }
          this.$nextTick(function () {
            this.formLampiran.setFieldsValue({
              document_name: response.data.document_name,
              upload_document_file: file2
            });
          });
        })
        .catch((err) => {
          console.log(err);
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
      } else {
        this.deductionDataEdit = val;
        this.deductionDataEdit['index'] = index;
        if (val.upload_tax_document && val.upload_tax_document.file) {
          this.fileListDtlLampiran.push(val.upload_tax_document.file);
        } else {
          this.fileListDtlLampiran = [];
        }
      }
    },
    deletedtl(index){
      this.loading.deletededuction = true;
      this.loading.deletedeductionKey = this.deduction_source[index].id_dtl;

      axios({
          method: "delete",
          url: this.$serviceUrl + "account_receivable/deduction",
          processData: false,
          data: {
            id: this.formModel.inputEditid,
            id_dtl: this.deduction_source[index].id_dtl
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
        .then((response) => {
          // this.deduction_source.splice(index, 1);
          this.deduction_source = response.data.dtl

          this.loading.deletededuction = false;
          this.loading.deletedeductionKey = "";
        })
        .catch((error) => {
          this.loading.deletededuction = false;
          this.loading.deletedeductionKey = "";

          let responses = Object.assign({}, error);
          if (responses.response.data) {
            this.displayMessageValue(
              "error-other",
              responses.response.data.message
            );
          } else {
            this.displayMessageValue("error-other", responses.response);
          }
        });
    },
    handleCancelEditItem(){
      this.deductionDataEdit = [];
      this.fileListDtlLampiran = [];
    },
    handleChangeEditItem(){
      this.formDeduction.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let formData = new FormData();

        let isvalid = true
        this.formLampiran.validateFields((err, values) => {
          if(values.document_name){
            formData.append("document_name", values.document_name);
            if(this.fileListModalLampiran && this.fileListModalLampiran[0]){
              formData.append("upload_document_file", this.fileListModalLampiran[0]);
            }else{
              this.displayMessageValue("error-other", "Upload Document File must be entried cause the document name has been entried!");
              isvalid = false
            }
          }
        })
        if(!isvalid){
          return;
        }

        formData.append(`id_dtl`, this.deductionDataEdit.id_dtl);
        formData.append("tlc", this.getAuth.username);
        formData.append("id", this.formModel.inputEditid);
        formData.append("jenis_transaksi", this.formModel.inputEditjns);

        formData.append(`type_tax`, values.type_tax);
        formData.append(`description`, values.description);
        formData.append(`value_tax`, values.value_tax);
        if(values.upload_tax_document && values.upload_tax_document.file)
          formData.append(`upload_tax_document`, values.upload_tax_document.file);

        this.loading.addeditdeduction = true;
        axios({
          method: "post",
          url: this.$serviceUrl + "account_receivable/deduction",
          processData: false,
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {

            // let editkeyIndex = this.deductionDataEdit.index;
            // let exist = _.filter(this.deduction_source,(item,index)=> item.type_tax==values.type_tax 
            //   && item.description.toLowerCase()==values.description.toLowerCase() && index!=editkeyIndex);
            // if(exist.length>0){
            //   this.displayMessageValue("error-other", "Data with type and description entry is exist!");
            //   return;
            // }
            // this.deduction_source[editkeyIndex].type_tax = values.type_tax;
            // this.deduction_source[editkeyIndex].description = values.description;
            // this.deduction_source[editkeyIndex].value_tax = values.value_tax;
            // if (this.fileListDtlLampiran.length > 0) {
            //   if (this.deduction_source[editkeyIndex].upload_tax_document) {
            //     this.deduction_source[editkeyIndex].upload_tax_document = { file: this.fileListDtlLampiran[0] };
            //   } else {
            //     this.deduction_source[editkeyIndex]['upload_tax_document'] = [];
            //     this.deduction_source[editkeyIndex].upload_tax_document = { file: this.fileListDtlLampiran[0] };
            //   }
            // } else {
            //   this.deduction_source[editkeyIndex].upload_tax_document = null;
            // }
            this.deduction_source = response.data.dtl;

            this.formDeduction.resetFields();
            this.deductionDataEdit = [];
            this.fileListDtlLampiran = [];

            this.loading.addeditdeduction = false;
          })
          .catch((error) => {
            this.loading.addeditdeduction = false;

            let responses = Object.assign({}, error);
            if (responses.response.data) {
              this.displayMessageValue(
                "error-other",
                responses.response.data.message
              );
            } else {
              this.displayMessageValue("error-other", responses.response);
            }
          });
      });
    },
    getcolortage(item){
      let result = "";
      if(item=="On Process"){
        result = "orange";
      }else if(item=="Revised"){
        result = "red";
      }else if(item=="Verified"){
        result = "green";
      }
      return result;
    },
    handleReleaseButton(item) {
      const that = this;
      this.loading.idrelease = item.id;

      this.$confirm({
        title: "Are you sure to release this data?",
        content: "",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          let data = new FormData();
          data.append("id", item.id);

          that.loading.release = true;
          that.asyncAxiosPost(
            "account_receivable/rilis_ar_sc",
            "formdata",
            that.getAuth,
            data
          )
          .then(() => {
            that.displayMessage("success-release");
            that.loading.release = false;
            that.loading.idrelease = "";
            that.handleReload();
          })
          .catch((err) => {
            that.loading.release = false;
            that.loading.idrelease = "";
            let response = Object.assign({}, err.response);
            if (response.data.status == false && response.data.message) {
              that.displayMessageValue("error-other", response.data.message);
            } else {
              let responses = Object.assign({}, err.response.data);
              that.displayMessageValue("error", responses);
            }
          });
        },
        onCancel() { },
      });
    },
    addARGeneral() {
      this.formARGeneral.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
          let formData = new FormData();
          formData.append("id", values.id);
          formData.append("jenis_transaksi", values.jenis_transaksi);
          formData.append("document_name", values.doc_name);
          formData.append("upload_document_file", values.upload_document_file.file);

          this.loading.submitARGeneral = true;
          axios({
            method: "post",
            url: this.$serviceUrl + "account_receivable/upload_attachment_ar",
            processData: false,
            data: formData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then(() => {
              this.loading.submitARGeneral = false;

              this.formARGeneral.resetFields();
              this.fileListModalARGeneral = [];
              this.modalARGeneral = false;

              this.displayMessage("success-upload");
              this.handleReload();
            })
            .catch((error) => {
              this.loading.submitARGeneral = false;

              let responses = Object.assign({}, error);
              if (responses.response.data) {
                this.displayMessageValue("error-other", responses.response.data.message);
              } else {
                this.displayMessageValue("error-other", responses.response);
              }
            });
      });
    },
    cancelARGeneral() {
      this.formARGeneral.resetFields();
      this.fileListModalARGeneral = [];
      this.modalARGeneral = false;
    }
  },
  watch: {
    "getAuth.divisi"() {
      if (this.getAuth && (this.getAuth.divisi[0] == "Akuntansi" || this.getAuth.divisi[0] == "Financial Control")) {
        this.tabs.active = "release";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);
  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border-bottom: 1px dashed darken(white, 10);
    padding: @padding;
  }
  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.bordered {
  border: 1px solid darken(white, 10);
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-item {
  display: flex;
  align-items: flex-start;
}

.result {
  margin: @padding 0;
  display: flex;
  justify-content: space-between;
}
</style>

<style lang="less">
.custom-tabs {
  .ant {
    &-tabs-bar {
      margin-bottom: 0;
    }
    &-tabs-content {
      flex: 1;
    }
  }
}

.ant-table-thead > tr > th {
  text-align: center !important;
}
</style>
